import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useContextProps } from 'react-aria-components';
import { twMerge } from '../../../../utils/twMerge.js';
import { DescriptionListItemContext } from '../DescriptionListItem.js';
export const DescriptionTerm = forwardRef(function DescriptionTerm(props, forwardedRef) {
    const [{ column = false, size, ...dtProps }, ref] = useContextProps(props, forwardedRef, DescriptionListItemContext);
    return (_jsx("dt", { ...dtProps, ref: ref, className: twMerge('ppl-DescriptionTerm', 'min-w-0 flex-none text-heading-sm text-default-subdued', column ? 'w-full' : 'basis-36', dtProps.className) }));
});
//# sourceMappingURL=DescriptionTerm.js.map